import { StaticPageLayout } from '../components/layout/StaticPageLayout'

// NOTE TO MICHAEL — this is a reasonable opening Refund Policy that aligns
// with how Stripe and the App Store actually behave. Two things to confirm
// before launch:
// • If you offer a free trial, double-check the trial-to-billing transition
//   wording matches what users actually see at checkout.
// • The 7-day discretionary refund window for web subscriptions is a
//   business choice, not a legal requirement. Adjust to whatever you're
//   comfortable honoring.

const REFUND_MARKDOWN = `We want you to be happy with PantryIO. If something isn't working out, here's how refunds work depending on where you subscribed.

## Free trial period

Pantry+ includes a 7-day free trial. You won't be charged during the trial period.

We'll send you a reminder email 3 days before the trial ends. You can cancel anytime during the trial via Settings → Subscription, and you won't be charged.

If you cancel after being charged, refunds are handled per the policy below.

## Web subscriptions (paid through Stripe)

If you subscribed on the web (through pantryioapp.com), we offer a goodwill refund within **7 days** of your initial purchase or first renewal charge, no questions asked.

To request a refund:

1. Email **support@pantryioapp.com** from the address on your PantryIO account.
2. Include the date of the charge and (if you have it) the last 4 digits of the card you used.
3. We'll process the refund to your original payment method within 5–10 business days.

After the 7-day window, web refunds are reviewed case-by-case. If the Service was unavailable for an extended period, if you were billed in error, or if you have another reason you think we should make an exception, email us — we'll do our best to make it right.

## iOS subscriptions (paid through the App Store)

If you subscribed through the App Store on an iPhone or iPad, **Apple processes all refunds for that subscription**. We are not able to issue refunds on Apple's behalf.

To request a refund from Apple:

1. Visit [reportaproblem.apple.com](https://reportaproblem.apple.com) and sign in with your Apple ID.
2. Find the PantryIO subscription charge.
3. Click "Report a Problem" and follow Apple's prompts.

Apple's refund policy is at their discretion. Decisions are typically made within 48 hours. If Apple denies your refund and you believe there's a billing error or service issue on our side, email us at support@pantryioapp.com and we'll see what we can do.

## Cancellation does not equal refund

Cancelling your subscription stops future renewals but does **not** automatically refund the current period. Your access continues through the end of the period you have already paid for, and then ends.

If you want both — cancel and refund — cancel through the appropriate channel (App Store or web), then email us within the refund window described above.

## What is not refundable

- **Charges older than the refund window** (7 days for web, Apple's discretion for App Store).
- **Annual subscriptions partway through the year**, except in cases of service unavailability or billing error.
- **Free-trial conversions where the user did not cancel before the trial ended**, unless covered by the standard 7-day web window.

We reserve the right to evaluate each refund request individually. We will always try to act in good faith.

## Contact

Questions or refund requests: **support@pantryioapp.com**

We aim to respond within 24 hours.
`

export default function RefundPolicy() {
  return (
    <StaticPageLayout
      documentTitle="Refund Policy — PantryIO"
      heading="Refund Policy"
      meta={<>Last updated: April 28, 2026</>}
      markdown={REFUND_MARKDOWN}
    />
  )
}
